/*
Note: Opting to not use i18n to avoid the overhead. If new languages are added,
migration to a dedicated translation approach will be a light lift.
*/

export const alertDisplay = {
  generic: {
    title: "Something went wrong",
    message: "We have been notified and are looking into it.",
  },

  restError: {
    byFailure: {
      "Internal error": {
        title: "Internal Server Error",
        message:
          "Something went wrong on our end. Please refresh and try again.",
      },
    },

    byErrorCode: {
      username_taken: {
        title: "Username unavailable",
        message: "That username is already taken. Please choose another.",
      },
      email_taken: {
        title: "Email unavailable",
        message:
          "An account already exists with that email. Please log in or use another email.",
      },
      email_and_username_taken: {
        title: "Email and username unavailable",
        message:
          "An account already exists with that email, and that username is taken. Please try another of each.",
      },
    },
  },
} as const
